/**
 * Required text to permanently delete an org (must match server).
 * Lowercase `delete` first, then a space, then the trimmed organization name.
 */
export function buildOrgDeleteConfirmPhrase(organizationName: string): string {
  return `delete ${organizationName.trim()}`
}
